import { Flex } from '@chakra-ui/react'
import { Illustration } from '~/components/member/Illustration'
import { MemberSection } from '~/components/member/layout'
import { ContactForm } from './ContactForm'
import { MemberSectionGuard } from './MemberGuard'

/** `/me/contact`: "Write to us". */
export default function Contact() {
  return (
    <MemberSectionGuard>
      {() => (
        <Flex gap={8} align='flex-start' direction={{ base: 'column', lg: 'row' }}>
          {/* No frame on a phone: a box inside a box costs a phone 28 px of its width. */}
          <MemberSection frameFrom='md' flex='1' w='full' maxW='3xl'>
            <ContactForm />
          </MemberSection>
          <Illustration name='contact' w={28} h={28} hideBelow='lg' />
        </Flex>
      )}
    </MemberSectionGuard>
  )
}
